import styled from '@emotion/styled';

import {
  spacing,
  borderRadius,
  typography,
  transitions,
  shadows,
  colors,
} from '../tokens';

const ACCENT = '#0B29FB';

export const SelectWrapper = styled('div', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $fullWidth: boolean }>`
  position: relative;
  display: ${({ $fullWidth }) => ($fullWidth ? 'block' : 'inline-block')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
`;

// ─── Trigger (pill "Selecione" + chevron) ─────────────────────────────────────

export const SelectTrigger = styled('button', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $open: boolean; $hasValue: boolean; $fullWidth: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing.md};
  box-sizing: border-box;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  min-width: 280px;
  height: 56px;
  padding: 0 ${spacing.xl};
  background: #ffffff;
  border: 1px solid ${({ $open }) => ($open ? '#3D3D3D' : '#595959')};
  border-radius: ${borderRadius.full};
  cursor: pointer;
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.regular};
  color: ${({ $hasValue }) => ($hasValue ? '#3D3D3D' : '#8C8C8C')};
  text-align: left;
  transition: border-color ${transitions.base};

  &:focus-visible {
    outline: none;
    border-color: ${ACCENT};
    box-shadow: 0 0 0 2px rgba(11, 41, 251, 0.15);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const TriggerText = styled('span')`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChevronWrap = styled('span', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $open: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  color: #262626;
  transition: transform ${transitions.base};
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});

  svg {
    width: 16px;
    height: 16px;
  }
`;

// ─── Lista (portal) ───────────────────────────────────────────────────────────

export const ContactList = styled('ul')`
  margin: 0;
  padding: ${spacing.sm} 0;
  list-style: none;
  background: #ffffff;
  border: 1px solid ${colors.border};
  border-radius: ${borderRadius.lg};
  box-shadow: ${shadows.lg};
  max-height: 320px;
  overflow-y: auto;
`;

export const ContactItem = styled('li', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $focused: boolean; $selected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: ${spacing.md} ${spacing.xl};
  cursor: pointer;
  background: ${({ $focused, $selected }) => {
    if ($selected) return '#EEF1FF';
    if ($focused) return colors.neutralBgDark;
    return 'transparent';
  }};
  transition: background ${transitions.fast};
`;

export const ContactName = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.extraBold};
  color: #3d3d3d;
  line-height: 1.3;
`;

export const ContactMeta = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.regular};
  color: ${colors.textSecondary};
  line-height: 1.3;
`;
